import { useState } from 'react'
import cutileiApi from 'services/cutileiApi'
import AlertDialog from 'components/AlertDialog'
import AuthService from 'services/auth'
import CheckBox from 'components/CheckBox'
import { FaEdit }from 'react-icons/fa'
import { DateTime } from 'luxon'
import { ReactComponent as Loading } from 'icons/loading2.svg'

import {
  Container,
  Row,
  CheckRow,
  Label,
  SubTitle,
  InfoText,
  Button
} from './styles'

export default function Holiday ({
  data: holiday,
  onEdit: handleEdit = () => {},
  onUpdated: handleUpdated = () => {}
}) {
  const [showConfirmDialog, setShowConfirmDialog] = useState (false)
  const [submitting, setSubmitting] = useState (false)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const handleSave = async action => {
    try {
      setSubmitting (true)

      const holidayData = {
        ...holiday,
        enabled: action === 'enable'
      }

      await cutileiApi.put (
        `/businesses/${businessId}/holidays/${holiday.id}`,
        holidayData,
        requestConfig
      )

      handleUpdated (holidayData)
    } catch (error) {
      console.error (error)
    } finally {
      setSubmitting (false)
    }
  }

  const toggleConfirmDialog = () => setShowConfirmDialog (!showConfirmDialog)

  const startDate = DateTime.fromISO (holiday.start_date).toFormat ('dd/MM/yyyy')
  const endDate = DateTime.fromISO (holiday.end_date).toFormat ('dd/MM/yyyy')

  return (
    <Container>
      {submitting ? (
        <Loading width={20} height={20}/>
      ) : (
        <Row>
          <CheckRow>
            <CheckBox
              id={`enable_holiday_${holiday.id}`}
              value={holiday.enabled}
              onValueChange={toggleConfirmDialog}
              disabled={holiday.enabled}
            />
            <Label htmlFor={`enable_holiday_${holiday.id}`}>
              Sim
            </Label>
          </CheckRow>
          <CheckRow>
            <CheckBox
              id={`disable_holiday_${holiday.id}`}
              value={!holiday.enabled}
              onValueChange={toggleConfirmDialog}
              disabled={!holiday.enabled}
            />
            <Label htmlFor={`disable_holiday_${holiday.id}`}>
              Não
            </Label>
          </CheckRow>
        </Row>
      )}
      <SubTitle>
        {holiday.start_date === holiday.end_date ? startDate : `${startDate} - ${endDate}`}
      </SubTitle>
      <InfoText>
        {holiday.name}
      </InfoText>
      <InfoText>
        {holiday.start_time}
      </InfoText>
      <InfoText>
        {holiday.end_time}
      </InfoText>
      {AuthService.hasPermission ('business_config.agenda', 'edit') && (
        <Button onClick={e => {
          e.stopPropagation ()
          handleEdit (holiday)
        }}>
          <FaEdit color='#35A7FF' size={18}/>
        </Button>
      )}
      <AlertDialog
        visible={showConfirmDialog}
        title='Atenção!'
        message={`Deseja realmente ${holiday.enabled ? 'fechar' : 'abrir'} sua agenda para a Cutilei neste feriado?`}
        confirmText='Sim'
        cancelText='Não'
        onConfirm={() => handleSave (holiday.enabled ? 'disable' : 'enable')}
        onClose={toggleConfirmDialog}
      />
    </Container>
  )
}
